import { Suspense } from 'react';
import examples, { routes } from 'examples-list';
import { Examples } from 'ExamplesIndex';
import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import { useStore } from 'store/store';
import styled, { ThemeProvider } from 'styled-components';

// A hack used to load just a json file without any HTML page structure.
// If we could have written Radial Park in NextJS we wouldn't have needed this.
const reload = () => window.location.reload();

// There is probably a better way to do this with React Router v6, but this still works.
// This routine takes the auto-generated examples-list json examples object and builds
// the necessary <Route> entries.
const makeRoutes = (list) => {
  return list
    .filter((item) => item.component)
    .map((route) => {
      return <Route key={route.path} path={route.path + '/*'} element={route.component} />;
    });
};
const makeIndexRoutes = (list) => {
  return list.map((route) => <Route key={route} path={route + '/*'} element={<Examples indexPath={route} />} />);
};

// If on localhost, change the title to make it easier to find the browser tab
if (window.location.href.includes('localhost')) document.title = 'Radial Park : LOCAL';

const App = styled(({ className }) => {
  const currentTheme = useStore((state) => state.themeConfig.theme);
  const examplesRoutes = makeRoutes(examples);
  const indexRoutes = routes ? makeIndexRoutes(routes) : null;
  return (
    <ThemeProvider theme={currentTheme}>
      <div className={className}>
        <Router>
          <Suspense fallback={<div>Page is loading...</div>}>
            <Routes>
              <Route path="/*" element={<Examples />} />
              {indexRoutes?.map((route) => route)}
              {examplesRoutes?.map((route) => route)}
              <Route path="/api/tags.json" onEnter={reload} />
            </Routes>
          </Suspense>
        </Router>
      </div>
    </ThemeProvider>
  );
})`
  font-family: 'Roboto';
`;

export default App;
